/**
 * 加载中组件
 * 
 * type 展现类型：full（全屏）、part（全屏）
 * name 动画类型：coffee_cup、typing_loader、circle、circle_side
 */
import React, { Component } from 'react';

import "./loadding.scss";

export class Loadding extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { type, name, noResult, text } = this.props;
        return (
            <div className={type === "full" ? "loadding full" : "loadding"}>
                {
                    noResult ?
                        <div className="no-result">{text ? text : "数据加载异常！请退出重试。"}</div>
                        :
                        name ?
                            <div className={name} />
                            : null
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/lib/loadding/Loadding.js